import { render } from "./ConfirmationCOBRAEnrollmentBenefit.vue?vue&type=template&id=68e06deb&ts=true"
import script from "./ConfirmationCOBRAEnrollmentBenefit.vue?vue&type=script&lang=ts"
export * from "./ConfirmationCOBRAEnrollmentBenefit.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__